window.VersionComparison = class {
  constructor(rootElement) {
    this.root = document.querySelector(rootElement);
    this.init();
  }

  init() {
    if (!this.root) {
      console.error("Version comparison root element not found.");
      return;
    }
    this.selectedVersion = this.root.getAttribute("data-version");
    this.toggles = this.root.querySelectorAll(".toggle-buttons > button");
    this.toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => this.toggle(toggle));
    });
  }

  toggle(toggle) {
    const version = toggle.getAttribute("data-version");
    if (version === this.selectedVersion) {
      return;
    }
    this.selectedVersion = version;
    this.root.setAttribute("data-version", version);
    this.toggles.forEach((t) => {
      t.setAttribute("aria-pressed", "false");
    });
    toggle.setAttribute("aria-pressed", "true");
  }
};
